module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "toc3"
    }
  }, [_vm._v("Rejected Project")])]), _c('a', {
    attrs: {
      "id": "toc3"
    }
  }, [_c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he office of Klaus Finkel was in an angle of the building and very well situated.  One of the two windows directly overlooked a clearing in the forest in which there was a small pond, and the view from there was much more attractive than it was from the other offices, which had too many nearby trees and through which there was much less natural light.  The view of the lake was relaxing to Finkel, and he had the custom of looking through the window for a while when had something worried him or he was angry with someone, which was not infrequent.  He was a person of very dry character and had shown himself to be irascible, for reasons that no one would consider important, especially with the technical and administrative personnel of the institute, for whom he had very little appreciation.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("That morning, Finkel was not at his best, since he had had an argument with his secretary, and he was looking at the pond through the window while taking on his mobile phone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There’s nothing that I can do, Dr. Schellenberg,” Finkel was saying.  “The Board of the Institute didn’t approve the contract with AAN.  It surprised me, too, and I am indignant.  It’s the first time that anything like this has happened, and I’m going to see what measures I can take.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dr. Schellenberg was one of the executives of AAN, who had been Finkel’s go between for preparing the research agreement regarding the nanoplate batteries.  For more than a quarter of an hour, they had been talking, since Finkel had called to advise of the Board’s decision.  Schellenberg was in no way satisfied with the explanations.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I acknowledge that, to me, it seems like a surprising and very strange decision,” said Schellenberg.  “We ‘ve been collaborating for many years with a multitude of research centers and, until now, we haven’t had a problem with this.  The proposal that you had me working together with you on regarding those nanoplate batteries seemed to me to be very interesting, and our director had approved it from the very first moment.  I’ve been personally involved with the proposal, but there have been some people in our firm who didn’t agree with it.  I’m afraid that this episode is going to affect our relationship in the future.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I understand perfectly, and I’m very sorry.  I don’t really want to get into the internal details of what goes on in our institute, but the truth is that I can’t say that our director would have supported us; on the contrary.  It isn’t the first problem that we’ve had... I don’t know what’s happening, but, at times, it’s difficult to understand some of the decisions.  Maybe it’s a generation gap,” said Finkel, the last sentence meant to sound like a joke.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see what you mean.  Professor Reimann has been with the institute for a long time, right?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, we haven’t had any other director since it was established. Before, things were going well, but we’re having more and more problems, there’s a lot less energy that there was before.  I suppose it’s something normal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Schellenberg’s attitude had been soothed by the explanations he had gotten from Finkel, and he now had a calmer tone, now that he had some insight into what had happened.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How old is Professor Reimann?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He’s two years from retirement age, and many of us have the strong impression that he is looking forward to it and that, meanwhile, he prefers not to rock the boat and to make as few decisions as possible.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course, it’s not a very comfortable situation for all of you, above all if he’s braking the initiatives.  It’s a shame because his institute depends on the most qualified people.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, it is a pity.  Many people here think that, but we will have to be patient.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In any case, getting back to the proposal, I was thinking that a department like yours could sign the research agreements, in a manner independent of the institute.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In theory, Dr. Schellenberg, only in theory.  It’s difficult to explain, but in practice, it’s better not to do it if the director isn’t in agreement.  I’m sorry not to be able to give you a greater explanation, I hope you understand me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Finkel ended the conversation with a few more polite sentences, and a little while later Mathias Steinfeld came into his office.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I just finished taking with Schellenberg at AAN,” Finkel told him without preamble. “I made it clear to him that we can’t do anything if Reimann is blocking the project and it’s not my fault.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Steinfeld let himself fall into one of the two chairs that were in front of Finkel’s desk with the air of someone who is worn out and is finally able to rest, as if instead of it being ten o’clock in the morning, it were the end of a day of intensive work.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure, he believed you.  Besides, it’s the truth.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come on, Klaus.  It’s OK to defend your position outside of here, but we don’t need you to end up believing it yourself. I’m sure that Reimann has suspected something’s going on.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Klaus Finkel, who had been so serious, ballooned into a smile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Reimann can speculate whatever he wants to, I don’t care.  The scheme worked out well, because it couldn’t fail. If the project is accepted, the institute would have been committed to a folly, and he would have been responsible.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, you noticed right away.  That’s why he didn’t want to approve it.  Nonetheless, it strikes me as strange that he would be so well informed on the matter of the nanoplate batteries... it’s not his field.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It didn’t surprise me.  I was counting on that and I presumed it was going to be documented.  The result is that he has blocked a project of his own institute with a business of the status of AAN, Schellenberg is indignant, and something like this isn’t going to increase his prestige.  These things get spread around, everybody ends up finding out about it, especially if we get on it.  Reimann isn’t going to get away with it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It’s OK, but that isn’t sufficient to demonstrate that the institute isn’t fulfilling its function; in fact, we won’t be hurt at all.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What has to be demonstrated is that the institute is poorly managed, that things could go much better with a different structure... that is to say that we function in spite of the bad management.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“By the way,” interrupted Mathias Steinfeld.  “I called Meier to find out about who the situation is with respect to the European Center for Research.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And, what did he tell you?” asked Finkel, with an expression of interest.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In his opinion, there is nothing to be done.  Dr. Bordan, that French woman who leads on the topic in Brussels, has made it quite clear that the establishment of the Centre, as we propose it, makes little sense, if the activity is similar to that of our institute. Meier suggested that, only if the Institute of New Energies and Nanotechnology offers to close and to integrate its research into the European Center, there are possibilities that that idea might gain wings and that the Center gets set up in Germany.  That, of course, Reimann is not going to permit.  He will defend this institute, that he considers as his, on top of everything, and has sufficient prestige and enough friends that the Ministry will pay attention to him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, for the moment he has enough prestige,” said Finkel, “but we’ll see how things evolve.  Neither the management of this institute, nor the state of its accounts, nor many other things, are as perfect as some believe.  If all that comes to light, maybe they’ll end up thinking that the Center is a good start, especially if we’re here, and we press for it.  Keep in mind that many people identify the institute with the persona of Reimann, and if Reimann fails... “")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I believe that, besides what you’ve said, the personal morality of Reimann leaves a lot to be desired.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you referring to?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We’ll talk about that in a moment.  What’s important is that, if Reimann’s failures come to light, one has to take a great deal of care that none of that splashes back on us personally.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“On the contrary.  We researchers will be those who suffer through a difficult situation on account of management.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In any case, it’s a risky game.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t think so.  I have told you many times.  I have guarantees that, if the European Center is set up here, the responsible principals would be ourselves.  I don’t need to tell you all that that means.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wolfgang Schmidt, one of the representatives of the researchers on the Steering Committee of the institute, the other was Dr. Bobic, had not been very satisfied with his decision of opposing Klaus Finkel in the meeting of the day before.  In reality, he didn’t like opposing anyone on anything, and he was trying to keep the lowest profile possible.  That was his intention, to abstain, after hearing the opposite opinions of Reimann and Finkel, but when the moment came and when he saw Mirjana Bobic supporting without any doubt the position of Reimann, he, too, without knowing very well why, did the same.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In reality, he felt admiration for his colleague, not just because he liked her physically, but because she usually had clear and determined ideas about whatever subject and, at the last moment, he voted with his colleague.  Since the end of the Committee meeting, it was the third time that he had gone in to Mirjana Bobic’s office to talk about the same thing:  the meeting of the committee and the possible consequences. Wolfgang was a tall, slender guy with ruddy cheeks, that was similar to the typical appearance of many people who live or have lived a lot of time on the farm.  His size, more than 6 feet 2 ¾ inches, didn’t come with a decided air, for he was bit shy and always a bit bent over, like someone who wanted to minimize his height and remain unnoticed.  When he entered her office, he was carrying two cups of coffee.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hello, Mirjana,” said Wolfgang.  “Would you like some coffee?  I made one for myself, and I thought you might like to have one, too.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mirjana Bobic, muttered something inaudible, stopped typing on her computer and lifted her gaze towards her visitor.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Thanks,” Bobic said, taking the cup he offered.  “I am writing the annual report for the renewal of my contract, and I haven’t had time to even go by the kitchen to have a cup.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What passed for a kitchen at the institute was a meeting room in which there was always a pair of carafes of hot coffee and in which the employees sat when they took a break in the middle of the morning or after lunch.  It was a comfortable meeting place in which, with too great a frequency, the theme of the conversation ended up being scientific.  Mirjana Bobic and Wolfgang Schmidt ran into each other quite often in that room, and they had become accustomed to chatting about their research and about the institute, in general.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The two were very different in every sense of the word.  She was short and slender with that slimness of physique of people of nervous character, who give the impression of never being calm.  She was blonde with fine features, short hair, and she wore small, frameless glasses that seemed to fit perfectly with her features.  Contrary to her associate, she seemed to have clear ideas about everything.  She took a sip of coffee and, then, after a brief pause, she said:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s good. I appreciate it, Wolfgang.  Well... now, I have to get back to my report.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mirjana...,” said Wolfgang hesitatingly.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes?” answered the woman who was disposed to continue her work on the computer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you think about yesterday’s meeting?  Do you believe that ")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Finkel is going to ask us for explanations for our having voted against his proposal?”")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wolfgang,” Mirjana said with a patient tone, such as she would use for explaining something to a child for whom it is necessary to repeat things many times.  “We’ve already talked about this.  I don’t understand your problem.  Finkel isn’t your boss.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know that, but my boss...” Wolfgang answered, referring to Dr. Müller, “abstained.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your boss has autistic tendencies and you don’t. I don’t believe that she cares how you voted.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s true.  She hasn’t said anything to me, but I wouldn’t want to upset anyone for how I voted as I did, and, above all, I’m not even sure whether I voted correctly or not.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mirjana Bobic, who had been throwing glances at her computer throughout their conversation with the hope that Wolfgang would decide to leave her to her work, propped her elbows on her desk, apparently abandoning the idea of continuing with her work.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Let’s see, Wolfgang,” she said.  “I know perfectly well that I voted correctly.  Finkel’s proposal was very strange, and I’m not convinced that there’s not something behind it, I can’t tell you what, but it was all very strange.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I... the truth is that I didn’t seen anything strange in the proposal, it seemed to me to be one of those things that’s always approved as a matter of course.  When Professor Reimann was opposed, I thought that it was for some personal reason.  You already know that Dr. Finkel is hardly very cooperative on matters that have to do with the institute.  I was thinking of abstaining or voting in favor of Finkel, but, when you voted against it, I decided to do the same as you.  You are always up on everything, and I am sure you had good reasons for how you voted.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Enough! What you’re telling me is that you voted the same as me because you trust me, and now you want to know why we opposed Finkel’s proposal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, you could say that... if you want.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Have you read anything about nanoplate batteries?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not really, no. It’s not my field, I’ve only heard something about it, but I have no opinion.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have.  I don’t work in it, but I have read a few things, and I’ve listened to a couple of presentations in the most recent conferences.  It’s a subject that’s very much in fashion, and there are some very important industries that are interested.  Everybody that works in that field and all the studies that have looked at it have reached the same conclusion.  They’re a long way from resolving the scientific problems and the techniques for developing these batteries.  As Reimann said, the most optimistic ones calculate that they’ll need about ten years.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But, Mirjana... if that is true, and I’m sure that it is the truth because you say so, I don’t understand the proposal of Finkel.  Why is he saying that he can do these batteries in a year?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“THAT is exactly what is so strange about all this.  Finkel isn’t an idiot, he’s not the nicest guy in the institute, but, generally, he knows what he’s about and is a good scientist.  I am sure that he knows perfectly well that his proposal isn’t viable.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then, why is he doing it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t know.  I think that he wanted us to reject the proposal, but I don’t know why.  I don’t know if he’s looking for some type of confrontation with Reimann or what he has in his head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Reimann is right when he told him that it doesn’t need the approval of the institute, if the contract with AAN were over his signature, but Finkel refused that.  He wanted the institute involved in all that at all costs.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I think you’re right, Mirjana, but... why is Finkel doing that?  The undertones of this story are over my head.  I don’t understand anything.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s over my head, too, but I’m going to try to find out about it.  As you know, it’s taken me a lot of work to get to a point where I can work tranquilly, I’m very happy here at the institute, and it aggravates me that they are creating tensions all around us without any apparent reason.  I believe that all of us will end up losing, if Finkel continues on this path.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mirjana Bobic came from the former Yugoslavia and had just finished her doctoral thesis in physics and was in the process of looking for work in some research center when the civil war had begun in her country.  Her home, the home of her parents, that was in one of the areas most affected by the war in Bosnia-Herzegovina, was completely destroyed and, after helping her parents to safety in a secure area with family in Serbia, she was able to get to Germany.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During her time as a student, she had spent two summers in Germany with the exchange program for science students; one doing practicums in a business in Cologne and the other in a laboratory at the University of Dusseldorf.  The contacts she made from those times were very useful for beginning her career in Germany, which had granted her legal residence.  Someone introduced and recommended her to Martin Reimann, who gave her a one-year contract at the institute in his own research group.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During that year, Bobic worked enthusiastically, connected very well with the group, and ended up being a person who was appreciated by everyone.  Now, after so many years, she already had a stable and important position inside Reimann’s group.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I already know that we will all lose with Finkel’s attitude,” said Wolfgang.  “I am also on Reimann’s side, the same as you.  I don’t know how to find out Finkel’s intentions, but if you find out anything...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If I find out anything, I will tell you, don’t worry.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And...  What’s going on with Mathias Steinfeld?  It seemed strange to me that he sided with Finkel, since he’s always been in agreement on everything with Reimann.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wolfgang, the truth... excuse me, but, sometimes, it seems that you come from a story book world.  Mathias is a typical upstart who is in agreement with the person who is interested in him in that moment, and he doesn’t mind changing his mind when it suits him.  He has made a career at Reimann’s side, and has done very well, but it’s been a long time already since he began to disagree and to go the other way anytime he can.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, it’s true, at times he becomes argumentative in the meetings of the Committee for reasons that don’t mean much.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I believe that he thinks Reimann is going to leave soon and that Finkel is going to have more influence than he has now, and that’s why he behaves that way, trying to cover himself for the future.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It could be, but he’s getting a bit ahead of himself.  In reality, nobody knows what’s going to happen to the institute when Reimann leaves, with two years remaining before he retires.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, there at still two more years.  Maybe Finkel and Mathias have some information that we don’t know and that’s why they’re acting that way.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 69
// module chunks = 0